/*! HarAndaz Maison — theme.js v1.0.0 | vanilla JS, no dependencies */
(() => {
  'use strict';

  const HA = (window.HA = window.HA || {});
  HA.ready = true;
  HA.routes = HA.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update', search: '/search', predictive: '/search/suggest' };
  HA.settings = HA.settings || {};
  HA.strings = HA.strings || {};

  const d = document;
  const html = d.documentElement;
  const $ = (s, r = d) => r.querySelector(s);
  const $$ = (s, r = d) => Array.from(r.querySelectorAll(s));
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);
  const debounce = (fn, ms = 250) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const mqTab = matchMedia('(min-width: 750px)');
  const mqDesk = matchMedia('(min-width: 990px)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hoverNone = matchMedia('(hover: none)');
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const store = {
    get(k, fb = null) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : fb; } catch (e) { return fb; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode */ } }
  };
  const SVG = (p, s = 20) => `<svg class="icon" width="${s}" height="${s}" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">${p}</svg>`;
  HA.icons = {
    close: SVG('<path d="M5.5 5.5l13 13M18.5 5.5l-13 13"/>'),
    plus: SVG('<path d="M12 5v14M5 12h14"/>', 14),
    minus: SVG('<path d="M5 12h14"/>', 14),
    check: SVG('<path d="M5 12.5l4.5 4.5L19 7.5"/>', 16),
    mute: SVG('<path d="M4 9.5h3.5L12 6v12l-4.5-3.5H4z"/><path d="M16 9.5l5 5M21 9.5l-5 5"/>', 18),
    sound: SVG('<path d="M4 9.5h3.5L12 6v12l-4.5-3.5H4z"/><path d="M16 9a4.5 4.5 0 0 1 0 6M18.5 6.5a8 8 0 0 1 0 11"/>', 18)
  };
  HA.esc = esc;
  HA.store = store;
  HA.debounce = debounce;

  /* ---------- Helpers ---------- */
  HA.path = (p) => {
    const root = (HA.routes.root || '/').replace(/\/$/, '');
    return root + p;
  };

  HA.formatMoney = (cents, format) => {
    format = format || HA.moneyFormat || 'Rs.{{amount_no_decimals}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Math.round(Number(cents) || 0);
    const fmt = (n, prec, th = ',', dec = '.') => {
      const parts = (n / 100).toFixed(prec).split('.');
      const int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts[1] ? int + dec + parts[1] : int;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return fmt(cents, 0, ' ');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return fmt(cents, 2, ' ', '.');
        default: return fmt(cents, 2);
      }
    });
  };
  const fm = (c) => HA.formatMoney(c);

  HA.fetchJSON = async (url, opts = {}) => {
    const res = await fetch(url, Object.assign({ credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } }, opts));
    let data = null;
    try { data = await res.json(); } catch (e) { /* empty */ }
    if (!res.ok) {
      const err = new Error((data && (data.description || data.message)) || res.statusText || 'Error');
      err.status = res.status; err.data = data;
      throw err;
    }
    return data;
  };
  HA.fetchHTML = async (url, opts = {}) => {
    const res = await fetch(url, Object.assign({ credentials: 'same-origin' }, opts));
    if (!res.ok) throw new Error('HTTP ' + res.status);
    return new DOMParser().parseFromString(await res.text(), 'text/html');
  };

  HA.toast = (msg, ms = 2800) => {
    const t = $('[data-toast]');
    if (!t || !msg) return;
    t.textContent = msg;
    t.classList.add('is-shown');
    clearTimeout(t._t);
    t._t = setTimeout(() => t.classList.remove('is-shown'), ms);
  };

  HA.publish = (name, data = {}) => {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('harandaz:' + name, data); } catch (e) { /* noop */ }
    try { d.dispatchEvent(new CustomEvent('harandaz:' + name, { detail: data })); } catch (e) { /* noop */ }
  };

  /* ---------- Attribution (UTM / click ids) ---------- */
  const SRC_KEY = 'ha_src';
  const SRC_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'ttclid', 'gclid'];
  const captureSource = () => {
    if (HA.settings.captureUtm === false) return;
    try {
      const p = new URLSearchParams(location.search);
      const found = {};
      SRC_KEYS.forEach((k) => { const v = p.get(k); if (v) found[k] = v.slice(0, 150); });
      let src = store.get(SRC_KEY);
      if (src && src.ts && Date.now() - src.ts > 30 * 864e5) src = null;
      const ref = (d.referrer && !d.referrer.includes(location.hostname)) ? d.referrer.slice(0, 150) : '';
      if (Object.keys(found).length) {
        src = Object.assign(found, { landing: location.pathname.slice(0, 150), referrer: ref, ts: Date.now() });
        store.set(SRC_KEY, src);
      } else if (!src) {
        store.set(SRC_KEY, { landing: location.pathname.slice(0, 150), referrer: ref, ts: Date.now() });
      }
    } catch (e) { /* noop */ }
  };
  HA.getSource = () => {
    const s = store.get(SRC_KEY);
    if (!s) return null;
    const out = {};
    SRC_KEYS.forEach((k) => { if (s[k]) out[k] = s[k]; });
    if (s.landing) out.landing_page = s.landing;
    if (s.referrer) out.referrer = s.referrer;
    return Object.keys(out).length ? out : null;
  };
  HA.cookie = (name) => {
    const m = d.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  };

  HA.checkoutUrl = (items, code) => {
    const base = HA.path('/cart/' + items.map((i) => `${i.id}:${i.quantity}`).join(','));
    const p = new URLSearchParams();
    if (code) p.set('discount', code);
    const src = HA.getSource();
    if (src) Object.keys(src).forEach((k) => p.set(`attributes[${k}]`, src[k]));
    const qs = p.toString();
    return base + (qs ? '?' + qs : '');
  };

  /* ---------- Drawers ---------- */
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
  const openDrawers = [];
  class HaDrawer extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.panel = this.querySelector('.drawer__panel');
      if (this.panel && !this.panel.hasAttribute('tabindex')) this.panel.setAttribute('tabindex', '-1');
      on(this, 'click', (e) => {
        const c = e.target.closest('[data-close]');
        if (c && this.contains(c) && c.closest('ha-drawer') === this) { e.preventDefault(); this.close(); }
      });
      on(this, 'keydown', (e) => {
        if (e.key === 'Escape') { e.stopPropagation(); this.close(); }
        else if (e.key === 'Tab') this.trap(e);
      });
    }
    get isOpen() { return this.classList.contains('is-open'); }
    open(opener) {
      if (this.isOpen) return this;
      openDrawers.slice().forEach((dr) => dr !== this && dr.close(true));
      this.opener = opener || d.activeElement;
      clearTimeout(this._t);
      this.hidden = false;
      void this.offsetWidth;
      this.classList.add('is-open');
      html.classList.add('is-locked');
      openDrawers.push(this);
      this.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true }));
      if (!this.contains(d.activeElement) && this.panel) this.panel.focus({ preventScroll: true });
      return this;
    }
    close(silent) {
      if (!this.isOpen) return;
      this.classList.remove('is-open');
      const i = openDrawers.indexOf(this);
      if (i > -1) openDrawers.splice(i, 1);
      if (!openDrawers.length) html.classList.remove('is-locked');
      this._t = setTimeout(() => { if (!this.isOpen) this.hidden = true; }, 600);
      if (!silent && this.opener && this.opener.focus && d.contains(this.opener)) this.opener.focus({ preventScroll: true });
      this.dispatchEvent(new CustomEvent('drawer:close', { bubbles: true }));
    }
    trap(e) {
      const f = $$(FOCUSABLE, this).filter((el) => el.offsetParent !== null || el === d.activeElement);
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && (d.activeElement === first || d.activeElement === this.panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  if (!customElements.get('ha-drawer')) customElements.define('ha-drawer', HaDrawer);
  HA.drawer = (id) => d.getElementById(id);
  HA.openDrawer = (id, opener) => { const el = d.getElementById(id); if (el && el.open) el.open(opener); return el; };
  on(d, 'keydown', (e) => { if (e.key === 'Escape' && openDrawers.length) openDrawers[openDrawers.length - 1].close(); });

  /* ---------- Header ---------- */
  const Header = {
    lastY: window.scrollY,
    ticking: false,
    bind() {
      this.sec = $('.hdr-section');
      this.hdr = $('[data-header]');
      this.ann = $('.ann-section');
      if (!this.hdr) return;
      this.mode = this.hdr.dataset.sticky || 'smart';
      this.measure();
      if ('ResizeObserver' in window) {
        this.ro && this.ro.disconnect();
        this.ro = new ResizeObserver(() => this.measure());
        this.ro.observe(this.hdr);
        if (this.ann) this.ro.observe(this.ann);
      }
      $$('.nav__item.has-dd', this.hdr).forEach((item) => {
        const link = item.querySelector('.nav__link');
        let t;
        on(item, 'mouseenter', () => { clearTimeout(t); link.setAttribute('aria-expanded', 'true'); });
        on(item, 'mouseleave', () => { t = setTimeout(() => { link.setAttribute('aria-expanded', 'false'); item.classList.remove('is-open'); }, 80); });
        on(link, 'click', (e) => {
          if (hoverNone.matches && !item.classList.contains('is-open')) {
            e.preventDefault();
            $$('.nav__item.is-open', this.hdr).forEach((x) => x.classList.remove('is-open'));
            item.classList.add('is-open');
            link.setAttribute('aria-expanded', 'true');
          }
        });
        on(item, 'focusout', (e) => { if (!item.contains(e.relatedTarget)) { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); } });
        on(item, 'keydown', (e) => { if (e.key === 'Escape') { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); link.focus(); } });
      });
      this.update();
    },
    measure() {
      if (!this.hdr) return;
      html.style.setProperty('--hdr-h', this.hdr.offsetHeight + 'px');
      html.style.setProperty('--ann-h', (this.ann ? this.ann.offsetHeight : 0) + 'px');
      this.update();
    },
    update() {
      if (!this.hdr) return;
      const y = Math.max(0, window.scrollY);
      const h = this.hdr.offsetHeight;
      const annH = this.ann ? this.ann.offsetHeight : 0;
      this.hdr.classList.toggle('is-solid', y > 10);
      if (this.mode === 'smart' && this.sec) {
        const dy = y - this.lastY;
        const busy = html.classList.contains('is-locked') || this.hdr.querySelector('.nav__item.is-open') || this.hdr.matches(':focus-within');
        if (y < h + annH + 40) this.sec.classList.remove('is-hidden');
        else if (dy > 6 && !busy) this.sec.classList.add('is-hidden');
        else if (dy < -6) this.sec.classList.remove('is-hidden');
      }
      const visible = this.mode !== 'none' && !(this.sec && this.sec.classList.contains('is-hidden'));
      html.style.setProperty('--hdr-offset', visible ? h + 'px' : '0px');
      this.lastY = y;
      this.ticking = false;
    }
  };
  on(window, 'scroll', () => { if (!Header.ticking) { Header.ticking = true; requestAnimationFrame(() => Header.update()); } }, { passive: true });
  on(window, 'resize', debounce(() => Header.measure(), 150));
  on(d, 'click', (e) => { if (!e.target.closest('.nav__item.has-dd')) $$('.nav__item.is-open').forEach((x) => x.classList.remove('is-open')); });

  /* ---------- Announcement ---------- */
  const initAnn = (root = d) => {
    $$('[data-ann]', root).forEach((ann) => {
      if (ann._init) return;
      ann._init = true;
      const msgs = $$('.ann__msg', ann);
      if (msgs.length < 2) return;
      let i = Math.max(0, msgs.findIndex((m) => m.classList.contains('is-active')));
      let timer;
      const speed = Math.max(2500, +ann.dataset.speed || 5000);
      const go = (n) => { msgs[i].classList.remove('is-active'); i = (n + msgs.length) % msgs.length; msgs[i].classList.add('is-active'); };
      const start = () => { clearInterval(timer); if (!reduced) timer = setInterval(() => go(i + 1), speed); };
      $$('[data-ann-step]', ann).forEach((b) => on(b, 'click', () => { go(i + Number(b.dataset.annStep)); start(); }));
      on(ann, 'mouseenter', () => clearInterval(timer));
      on(ann, 'mouseleave', start);
      ann._go = (n) => { clearInterval(timer); go(n); };
      start();
    });
  };

  /* ---------- Reveal on scroll ---------- */
  let rvIO = null;
  const revealIn = (root = d) => {
    const els = $$('.rv:not(.is-in)', root);
    if (!els.length) return;
    if (!html.classList.contains('has-anim') || HA.designMode || reduced || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    rvIO = rvIO || new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); rvIO.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
    els.forEach((el) => rvIO.observe(el));
  };
  HA.revealIn = revealIn;

  /* ---------- Slider ---------- */
  class HaSlider extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this.track = this.querySelector('[data-slider-track]');
      if (!this.track) return;
      this._init = true;
      this.prev = this.querySelector('[data-slider-prev]');
      this.next = this.querySelector('[data-slider-next]');
      this.update = this.update.bind(this);
      on(this.prev, 'click', () => this.step(-1));
      on(this.next, 'click', () => this.step(1));
      on(this.track, 'scroll', debounce(this.update, 60), { passive: true });
      if ('ResizeObserver' in window) { this.ro = new ResizeObserver(this.update); this.ro.observe(this.track); }
      this.update();
    }
    disconnectedCallback() { if (this.ro) this.ro.disconnect(); }
    step(dir) {
      const item = this.track.firstElementChild;
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const w = item.getBoundingClientRect().width + gap;
      const per = Math.max(1, Math.floor((this.track.clientWidth + gap) / w));
      this.track.scrollBy({ left: dir * w * per, behavior: reduced ? 'auto' : 'smooth' });
    }
    update() {
      const t = this.track;
      if (!t) return;
      const max = t.scrollWidth - t.clientWidth - 2;
      this.classList.toggle('is-static', max <= 0);
      if (this.prev) this.prev.disabled = t.scrollLeft <= 2;
      if (this.next) this.next.disabled = t.scrollLeft >= max;
    }
  }
  if (!customElements.get('ha-slider')) customElements.define('ha-slider', HaSlider);

  /* ---------- Hero ---------- */
  class HaHero extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();this.observer?.disconnect();this.pause();
      this.controller=new AbortController();const listen=(target,event,fn,options={})=>target.addEventListener(event,fn,{...options,signal:this.controller.signal});
      this.slides=$$('[data-slide]',this);this.bars=$$('[data-go]',this);this.i=Math.max(0,this.slides.findIndex(s=>s.classList.contains('is-active')));
      this.speed=Math.max(3000,+this.dataset.speed||6000);this.auto=this.dataset.autoplay!=='false';this.inView=true;this.hovered=false;this.focused=false;this.userPaused=false;
      const sync=()=>{this.playVideo();this.pause();this.play();};
      this.slides.forEach((slide,index)=>{slide.inert=index!==this.i;slide.setAttribute('aria-hidden',String(index!==this.i));});
      this.bars.forEach(bar=>listen(bar,'click',()=>{this.go(+bar.dataset.go);this.restart();}));
      const toggle=this.querySelector('[data-hero-toggle]');if(toggle)listen(toggle,'click',()=>{this.userPaused=!this.userPaused;toggle.setAttribute('aria-pressed',String(this.userPaused));sync();});
      listen(this,'mouseenter',()=>{this.hovered=true;sync();});listen(this,'mouseleave',()=>{this.hovered=false;sync();});
      listen(this,'focusin',()=>{this.focused=true;sync();});listen(this,'focusout',()=>queueMicrotask(()=>{if(!this.isConnected)return;this.focused=this.matches(':focus-within');sync();}));
      listen(d,'visibilitychange',sync);
      let x=null,y=null;listen(this,'touchstart',event=>{x=event.touches[0].clientX;y=event.touches[0].clientY;},{passive:true});
      listen(this,'touchend',event=>{if(x===null)return;const dx=event.changedTouches[0].clientX-x,dy=event.changedTouches[0].clientY-y;if(this.slides.length>1&&Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.2){this.go(this.i+(dx<0?1:-1));this.restart();}x=null;},{passive:true});
      if('IntersectionObserver' in window){this.observer=new IntersectionObserver(([entry])=>{this.inView=entry.isIntersecting;sync();});this.observer.observe(this);}sync();
    }
    disconnectedCallback(){this.pause();this.controller?.abort();this.observer?.disconnect();this.slides?.forEach(slide=>slide.querySelector('video')?.pause());}
    playVideo(){this.slides?.forEach((slide,index)=>{const video=slide.querySelector('video');if(!video)return;video.muted=true;video.playsInline=true;if(index===this.i&&!reduced&&!d.hidden&&this.inView&&!this.userPaused){video.play()?.catch(()=>{});}else video.pause();});}
    go(index){if(!this.slides.length)return;const next=(index%this.slides.length+this.slides.length)%this.slides.length;this.i=next;this.slides.forEach((slide,k)=>{const active=k===next;slide.classList.toggle('is-active',active);slide.inert=!active;slide.setAttribute('aria-hidden',String(!active));});this.bars.forEach((bar,k)=>{bar.classList.toggle('is-active',k===next);bar.setAttribute('aria-current',String(k===next));});this.playVideo();}
    resetBar(){const bar=this.bars?.[this.i];if(!bar)return;bar.classList.remove('is-active');void bar.offsetWidth;bar.classList.add('is-active');}
    play(){if(!this.auto||reduced||this.timer||!this.inView||d.hidden||this.hovered||this.focused||this.userPaused||this.slides.length<2)return;this.classList.remove('is-paused');this.resetBar();this.timer=setInterval(()=>this.go(this.i+1),this.speed);}
    pause(){clearInterval(this.timer);this.timer=null;this.classList.add('is-paused');}
    restart(){this.pause();this.play();}
  }
  if (!customElements.get('ha-hero')) customElements.define('ha-hero', HaHero);

  /* ---------- Tabs ---------- */
  class HaTabs extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();this.controller=new AbortController();
      const buttons=$$('[data-tab]',this),panels=$$('[data-panel]',this);
      const select=(button,focus=false)=>{
        buttons.forEach(x=>{const active=x===button;x.classList.toggle('is-active',active);x.setAttribute('aria-selected',String(active));x.tabIndex=active?0:-1;});
        panels.forEach(panel=>{const active=panel.dataset.panel===button.dataset.tab;panel.hidden=!active;panel.classList.toggle('is-active',active);if(active){$$('ha-slider',panel).forEach(s=>s.update?.());revealIn(panel);}});
        if(focus)button.focus();
      };
      buttons.forEach((button,index)=>{
        const panel=panels.find(p=>p.dataset.panel===button.dataset.tab);
        if(panel){button.id=button.id||'ha-tab-'+this.closest('[id]')?.id+'-'+index;panel.id=panel.id||button.id+'-panel';button.setAttribute('aria-controls',panel.id);panel.setAttribute('aria-labelledby',button.id);}
        button.addEventListener('click',()=>select(button),{signal:this.controller.signal});
        button.addEventListener('keydown',event=>{let i=index;if(event.key==='ArrowRight')i=(index+1)%buttons.length;else if(event.key==='ArrowLeft')i=(index+buttons.length-1)%buttons.length;else if(event.key==='Home')i=0;else if(event.key==='End')i=buttons.length-1;else return;event.preventDefault();select(buttons[i],true);},{signal:this.controller.signal});
      });
      const initial=buttons.find(b=>b.classList.contains('is-active'))||buttons[0];if(initial)select(initial);
    }
    disconnectedCallback(){this.controller?.abort();}
  }
  if (!customElements.get('ha-tabs')) customElements.define('ha-tabs', HaTabs);

  /* ---------- Cart ---------- */
  HA.cart = {
    bundleRules: new Map(),
    captureBundleRules() {
      $$('[data-cart-bundle-rules]').forEach(el=>{try{const rule=JSON.parse(el.textContent);this.bundleRules.set(Number(rule.id),rule.tiers||[]);}catch{}});
      $$('[data-product-meta]').forEach(el=>{try{const meta=JSON.parse(el.textContent);if(Array.isArray(meta.bundleTiers))this.bundleRules.set(Number(meta.id),meta.bundleTiers);}catch{}});
    },
    sectionIds() {
      const ids = [];
      if ($('#CartDrawer')) ids.push('cart-drawer');
      const page = $('[data-cart-page]');
      if (page && page.dataset.section) ids.push(page.dataset.section);
      return ids;
    },
    render(sections) {
      this.captureBundleRules();
      if (!sections) return;
      Object.keys(sections).forEach((id) => {
        const markup = sections[id];
        if (!markup) return;
        const doc = new DOMParser().parseFromString(markup, 'text/html');
        const fresh = doc.querySelector('[data-cart-root]');
        const target = id === 'cart-drawer' ? $('#CartDrawer [data-cart-root]') : $(`[data-cart-page][data-section="${id}"] [data-cart-root]`);
        if (fresh && target) {
          target.innerHTML = fresh.innerHTML;
          target.dataset.count = fresh.dataset.count;
        }
      });
      this.captureBundleRules();
      const root = $('#CartDrawer [data-cart-root]') || $('[data-cart-root]');
      if (root && root.dataset.count != null) this.setCount(+root.dataset.count);
    },
    setCount(n) {
      $$('[data-cart-count]').forEach((el) => {
        const changed = el.textContent.trim() !== String(n);
        el.textContent = n;
        el.hidden = !n;
        if (changed && n) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
      });
    },
    async get() { return HA.fetchJSON(HA.routes.cart + '.js'); },
    async applyDiscount(code) {
      const current=await this.get();
      this.captureBundleRules();
      const bundleCodes=[...this.bundleRules.values()].flat().map(t=>String(t.code).toLowerCase());
      const codes=(current.discount_codes||[]).map(entry=>entry.code).filter(existing=>!bundleCodes.includes(existing.toLowerCase()));
      let best=null;
      for(const [id,tiers] of this.bundleRules){const count=current.items.filter(item=>Number(item.product_id)===id).reduce((sum,item)=>sum+item.quantity,0);const tier=tiers.filter(t=>t.code&&Number(t.min)<=count).sort((a,b)=>Number(b.min)-Number(a.min))[0];if(tier){const saving=Number(tier.amount)*(tier.each?count:1);if(!best||saving>best.saving)best={code:tier.code,saving};}}
      code=best?.code||'';
      if(code)codes.push(code);
      const target=[...new Set(codes)].map(c=>c.toLowerCase()).sort().join(',');
      const existing=(current.discount_codes||[]).map(c=>c.code.toLowerCase()).sort().join(',');
      if(target===existing)return current;
      const ids=this.sectionIds();const body={discount:[...new Set(codes)].join(',')};
      if(ids.length){body.sections=ids.join(',');body.sections_url=location.pathname;}
      const result=await HA.fetchJSON(HA.routes.cartUpdate+'.js',{method:'POST',body:JSON.stringify(body)});
      if(result.sections)this.render(result.sections);else await this.refresh();
      const applied=(result.discount_codes||[]).find(entry=>code&&entry.code.toLowerCase()===code.toLowerCase());
      if(applied&&applied.applicable===false)throw new Error(HA.strings.bundleUnavailable);
      return result;
    },
    async add(items) {
      const ids = this.sectionIds();
      const body = { items };
      if (ids.length) { body.sections = ids.join(','); body.sections_url = location.pathname; }
      const res = await HA.fetchJSON(HA.routes.cartAdd + '.js', { method: 'POST', body: JSON.stringify(body) });
      if (res.sections) this.render(res.sections); else await this.refresh();
      this.syncAttrs();
      try{await this.applyDiscount('');}catch{HA.toast(HA.strings.addedOfferFailed||'Added to your bag. Check your discount before checkout.');}
      const first = (res.items && res.items[0]) || res;
      HA.publish('add_to_cart', { variant_id: first.variant_id || first.id, product_id: first.product_id, title: first.product_title || first.title, quantity: first.quantity, price: (first.final_price || first.price || 0) / 100, currency: HA.currency });
      return res;
    },
    async change(line, quantity) {
      this.captureBundleRules();
      const ids = this.sectionIds();
      const body = { line, quantity };
      if (ids.length) { body.sections = ids.join(','); body.sections_url = location.pathname; }
      const res = await HA.fetchJSON(HA.routes.cartChange + '.js', { method: 'POST', body: JSON.stringify(body) });
      if (res.sections) this.render(res.sections); else await this.refresh();
      await this.applyDiscount('');
      return res;
    },
    async refresh() {
      const ids = this.sectionIds();
      if (!ids.length) return;
      try {
        const res = await fetch(`${location.pathname}?sections=${ids.join(',')}`, { credentials: 'same-origin' });
        this.render(await res.json());
      } catch (e) { /* noop */ }
    },
    async clear() {
      try { await HA.fetchJSON(HA.routes.cart + '/clear.js', { method: 'POST', body: '{}' }); } catch (e) { /* noop */ }
      await this.refresh();
    },
    async syncAttrs() {
      const src = HA.getSource();
      if (!src) return;
      const sig = JSON.stringify(src);
      try { if (sessionStorage.getItem('ha_src_synced') === sig) return; } catch (e) { /* noop */ }
      try {
        await HA.fetchJSON(HA.routes.cartUpdate + '.js', { method: 'POST', body: JSON.stringify({ attributes: src }) });
        sessionStorage.setItem('ha_src_synced', sig);
      } catch (e) { /* noop */ }
    },
    afterAdd() {
      if (HA.settings.cartType === 'drawer' && $('#CartDrawer') && !$('[data-cart-page]')) HA.openDrawer('CartDrawer');
      else HA.toast(HA.strings.added);
    }
  };

  const changeLine = (line, qty) => {
    if (!line) return;
    clearTimeout(line._t);
    line._t = setTimeout(async () => {
      line.classList.add(qty === 0 ? 'is-removing' : 'is-loading');
      try { await HA.cart.change(Number(line.dataset.index), qty); }
      catch (e) { HA.toast(e.message || HA.strings.cartError); line.classList.remove('is-loading', 'is-removing'); HA.cart.refresh(); }
    }, qty === 0 ? 0 : 350);
  };

  on(d, 'click', (e) => {
    const extra=e.target.closest('[data-cart-add-pair]');
    if(extra){e.preventDefault();if(extra.disabled)return;const select=extra.closest('[data-cart-offers]').querySelector('[data-cart-pair-variant]');if(!select?.value)return;extra.disabled=true;(async()=>{try{await HA.cart.add([{id:Number(select.value),quantity:1}]);}catch(error){HA.toast(error.message||HA.strings.cartError);}finally{extra.disabled=false;}})();return;}
    const offer=e.target.closest('[data-cart-offer]');
    if(offer){e.preventDefault();if(offer.disabled)return;offer.disabled=true;offer.setAttribute('aria-busy','true');HA.cart.applyDiscount(offer.dataset.cartOffer).then(()=>HA.toast(HA.strings.bundleUpdated)).catch(error=>HA.toast(error.message||HA.strings.cartError)).finally(()=>{offer.disabled=false;offer.removeAttribute('aria-busy');});return;}
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.closest('[data-line]'), 0); return; }
    const step = e.target.closest('[data-qty-step]');
    if (step && step.closest('[data-line]')) {
      const input = step.closest('[data-qty]').querySelector('input');
      const v = Math.max(0, Math.min(99, (parseInt(input.value, 10) || 0) + Number(step.dataset.qtyStep)));
      input.value = v;
      changeLine(step.closest('[data-line]'), v);
      return;
    }
    const addV = e.target.closest('[data-add-variant]');
    if (addV) {
      e.preventDefault();
      if(addV.disabled)return;
      addV.disabled=true;
      addV.classList.add('is-loading');
      HA.cart.add([{ id: Number(addV.dataset.addVariant), quantity: 1 }])
        .then(() => { if (!addV.closest('#CartDrawer')) HA.cart.afterAdd(); })
        .catch((err) => HA.toast(err.message || HA.strings.cartError))
        .finally(() => {addV.disabled=false;addV.classList.remove('is-loading');});
      return;
    }
    const cartOpen = e.target.closest('[data-cart-open]');
    if (cartOpen && HA.settings.cartType === 'drawer' && $('#CartDrawer') && !$('[data-cart-page]')) {
      e.preventDefault();
      HA.openDrawer('CartDrawer', cartOpen);
      return;
    }
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const dr = d.getElementById(opener.dataset.open);
      if (dr && dr.open) { e.preventDefault(); dr.open(opener); }
    }
  });
  on(d, 'change', (e) => {
    if (e.target.matches('[data-line-qty]')) changeLine(e.target.closest('[data-line]'), Math.max(0, parseInt(e.target.value, 10) || 0));
  });
  const saveNote = debounce((v) => { HA.fetchJSON(HA.routes.cartUpdate + '.js', { method: 'POST', body: JSON.stringify({ note: v }) }).catch(() => {}); }, 600);
  on(d, 'input', (e) => { if (e.target.matches('[data-cart-note]')) saveNote(e.target.value); });

  /* ---------- Quick view ---------- */
  const openQuick = async (url, opener) => {
    const dr = $('#QuickView');
    if (!dr) { location.href = url; return; }
    const body = $('[data-quick-body]', dr);
    body.innerHTML = '';
    body.classList.add('is-loading');
    dr.open(opener);
    try {
      const u = new URL(url, location.origin);
      u.searchParams.set('section_id', 'ha-quick-view');
      const doc = await HA.fetchHTML(u.toString());
      const el = doc.querySelector('ha-product');
      if (!el) throw new Error('No product');
      body.classList.remove('is-loading');
      body.replaceChildren(d.importNode(el, true));
      HA.publish('quick_view', { url });
    } catch (e) {
      location.href = url;
    }
  };
  on(d, 'click', (e) => {
    const q = e.target.closest('[data-quick]');
    if (!q) return;
    e.preventDefault();
    openQuick(q.dataset.quick, q);
  });

  /* ---------- Product ---------- */
  const RV_KEY = 'ha_recent';
  const recordRecent = (handle) => {
    if (!handle) return;
    const list = store.get(RV_KEY, []).filter((h) => h !== handle);
    list.unshift(handle);
    store.set(RV_KEY, list.slice(0, 12));
  };

  class HaProduct extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      try { this.variants = JSON.parse(($('script[data-variants]', this) || {}).textContent || '[]'); } catch (e) { this.variants = []; }
      try { this.meta = JSON.parse(($('script[data-product-meta]', this) || {}).textContent || '{}'); } catch (e) { this.meta = {}; }
      this.isMain = this.hasAttribute('data-main-product');
      this.form = $('[data-product-form]', this);
      this.idInput = $('[data-variant-id]', this);
      this.qtyInput = $('[data-qty-input]', this);
      this.formQty = $('[data-form-qty]', this);
      this.offers = $('[data-offers]', this);
      const guideWrap=this.querySelector('.pdp__size'),guideButton=guideWrap?.querySelector('[data-open]');
      const sizeField=[...this.querySelectorAll('.vp__opt')].find(field=>{const name=field.querySelector('legend span')?.textContent.split(':')[0].trim().toLowerCase();return ['size','shoe size','eu size'].includes(name);});
      if(guideButton&&sizeField){const legend=sizeField.querySelector('legend');legend.classList.add('vp__label--with-guide');guideButton.classList.add('size-guide-inline');legend.append(guideButton);guideWrap.remove();}

      this.offer = { qty: 1, pct: 0, code: '' };
      const id = Number(this.idInput && this.idInput.value);
      this.variant = this.variants.find((v) => v.id === id) || this.variants.find((v) => v.available) || this.variants[0] || null;
      on(this, 'change', (e) => this.onChange(e));
      on(this, 'click', (e) => this.onClick(e));
      if (this.form) on(this.form, 'submit', (e) => { e.preventDefault(); this.addToCart(); });
      this.initGallery();
      this.initStickyBar();
      this.initStickable();
      this.updateUnavailable();
      this.updateStock();
      this.updateWa();
      if (this.offers) { const c = $('input:checked', this.offers); if (c) this.setOffer(c); }
      if (this.isMain) {
        recordRecent(this.meta.handle);
        const v = this.variant;
        HA.publish('product_view', { product_id: this.meta.id, title: this.meta.title, variant_id: v && v.id, price: v ? v.price / 100 : 0, currency: HA.currency });
      }
    }
    onChange(e) {
      const t = e.target;
      if (t.classList.contains('vp__input')) this.onOption(t);
      else if (this.offers && this.offers.contains(t) && t.type === 'radio') this.setOffer(t);
      else if (t.matches('[data-qty-input]')) this.offers ? this.setBundleCount(parseInt(t.value, 10) || 1) : this.setQty(parseInt(t.value, 10) || 1);
    }
    onClick(e) {
      const step = e.target.closest('[data-qty-step]');
      if (step && step.closest('.pdp__qty')) {
        e.preventDefault();
        this.offers ? this.setBundleCount(this.getQty() + Number(step.dataset.qtyStep)) : this.setQty(this.getQty() + Number(step.dataset.qtyStep));
        return;
      }
      const stickyAdd = e.target.closest('[data-sticky-add]');
      if (stickyAdd) { e.preventDefault(); this.addToCart(stickyAdd); return; }
      const order = e.target.closest('[data-order-now]');
      if (order) { e.preventDefault(); this.orderNow(order); return; }
      const zoom = e.target.closest('[data-zoom]');
      if (zoom) { e.preventDefault(); this.openZoom(zoom); }
    }
    selected() {
      return $$('[data-option-index]', this).map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
    }
    onOption(input) {
      const sel = this.selected();
      const idx = Number(input.closest('[data-option-index]').dataset.optionIndex);
      let v = this.variants.find((x) => x.options.every((o, k) => o === sel[k]));
      if (!v) {
        v = this.variants.find((x) => x.available && x.options[idx] === input.value) || this.variants.find((x) => x.options[idx] === input.value) || null;
        if (v) {
          $$('[data-option-index]', this).forEach((fs, k) => {
            const r = $$('input', fs).find((x) => x.value === v.options[k]);
            if (r) r.checked = true;
          });
        }
      }
      this.setVariant(v);
    }
    setVariant(v) {
      this.variant = v;
      if (this.idInput) this.idInput.value = v ? v.id : '';
      $$('[data-option-index]', this).forEach((fs) => {
        const s = $('[data-option-selected]', fs);
        const c = $('input:checked', fs);
        if (s && c) s.textContent = c.value;
      });
      this.updatePrice();
      this.updateButtons();
      this.updateStock();
      this.updateUnavailable();
      this.updateMedia();
      this.updateOfferPrices();
      this.updateWa();
      if (this.isMain && v) {
        try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) { /* noop */ }
      }
      this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v } }));
    }
    updatePrice() {
      const v = this.variant;
      const box = $('.pdp__price [data-price]', this);
      if (box && v) {
        const now = $('[data-price-now]', box);
        const was = $('[data-price-was]', box);
        const save = $('[data-price-save]', box);
        const sale = v.compare > v.price;
        const percent = $('[data-discount-percent]', box);
        if(percent){percent.hidden=!sale;percent.textContent=sale?Math.round((v.compare-v.price)/v.compare*100)+'% OFF':'';}
        box.classList.toggle('price--sale', sale);
        if (now) now.textContent = fm(v.price);
        if (was) { was.hidden = !sale; was.textContent = sale ? fm(v.compare) : ''; }
        if (save) { save.hidden = !sale; save.textContent = sale ? `${HA.strings.save || 'Save'} ${fm(v.compare - v.price)}` : ''; }
      }
      const sp = $('[data-sticky-price]', this);
      if (sp && v) sp.textContent = fm(v.price);
    }
    updateButtons() {
      const v = this.variant;
      const avail = !!(v && v.available);
      const txt = (def) => (!v ? HA.strings.unavailable : avail ? def : HA.strings.soldOut);
      $$('[data-order-now]', this).forEach((b) => {
        b.disabled = !avail;
        const l = $('[data-order-label]', b);
        if (l) l.textContent = txt(b.closest('.sticky-buy') ? (HA.strings.orderNow || 'Order Now') : (HA.strings.orderLabel || HA.strings.orderNow || 'Order Now'));
      });
      $$('[data-add-to-cart],[data-sticky-add]', this).forEach((b) => {
        b.disabled = !avail;
        const l = $('[data-add-label]', b);
        if (l) l.textContent = txt(HA.strings.addToCart || 'Add to bag');
      });
    }
    updateStock() {
      const el = $('[data-stock]', this);
      const urg = $('.pdp-stock-urgency', this);
      const v = this.variant;
      if (urg) urg.style.display = v && v.available ? '' : 'none';
      if (!el) return;
      const txt = $('[data-stock-text]', el);
      const th = Number(el.dataset.threshold) || 0;
      el.classList.remove('is-low', 'is-out');
      if (!v || !v.available) {
        el.classList.add('is-out');
        el.style.display = '';
        if (txt) txt.textContent = v ? HA.strings.soldOut : HA.strings.unavailable;
        return;
      }
      if (el.dataset.showInStock === 'false') {
        el.style.display = 'none';
        return;
      }
      el.style.display = '';
      if (v.m === 'shopify' && v.p !== 'continue' && v.q > 0 && v.q <= th) {
        el.classList.add('is-low');
        if (txt) txt.textContent = (HA.strings.lowStock || '').replace('999', v.q);
      } else if (txt) txt.textContent = HA.strings.inStock;
    }
    updateUnavailable() {
      const sets = $$('[data-option-index]', this);
      if (!sets.length) return;
      const sel = this.selected();
      sets.forEach((fs, i) => {
        $$('.vp__input', fs).forEach((inp) => {
          const ok = this.variants.some((v) => v.available && v.options[i] === inp.value && v.options.every((o, k) => k >= i || o === sel[k]));
          const lbl = inp.nextElementSibling;
          if (lbl) lbl.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    updateMedia() {
      const v = this.variant;
      if (!v || !v.media || !this.track) return;
      const item = $(`[data-media-id="${v.media}"]`, this.track);
      if (!item) return;
      if (getComputedStyle(this.track).display === 'grid') {
        if (this.track.firstElementChild !== item) this.track.prepend(item);
      } else {
        this.track.scrollTo({ left: item.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      }
    }
    updateWa() {
      const a = $('[data-wa-product]', this);
      if (!a || !this.variant) return;
      try {
        const u = new URL(a.href);
        if (!a.dataset.base) a.dataset.base = u.searchParams.get('text') || '';
        let t = a.dataset.base;
        if (!this.meta.single && this.variant.title) t = t.replace(' — ', ` (${this.variant.title}) — `);
        t = t.replace(/(\/products\/[^\s?]+)/, `$1?variant=${this.variant.id}`);
        a.href = `https://wa.me/${a.dataset.waNumber}?text=${encodeURIComponent(t)}`;
      } catch (e) { /* noop */ }
    }
    getQty() { return Math.max(1, parseInt((this.formQty && this.formQty.value) || (this.qtyInput && this.qtyInput.value) || 1, 10) || 1); }
    setQty(n) {
      n = Math.min(20, Math.max(1, n | 0));
      if (this.formQty) this.formQty.value = n;
      if (this.qtyInput) this.qtyInput.value = n;
    }
    setOffer(input) {
      $$('.offer', this.offers).forEach((l) => l.classList.toggle('is-active', l.contains(input)));
      this.offer = { qty: Number(input.dataset.qty) || 1, pct: Number(input.dataset.pct) || 0, discount: Number(input.dataset.discount) || 0, code: input.dataset.code || '' };
      const tier=this.bundleTier(this.offer.qty);this.offer.discount=tier.discount;this.offer.code=tier.code;
      this.setQty(this.offer.qty);
      this.renderBundleChoices();
      this.updateOfferPrices();
    }
    bundleTier(count) {
      const tiers=Array.isArray(this.meta.bundleTiers)?this.meta.bundleTiers:[];
      const tier=tiers.filter(t=>t.code&&Number(t.min)<=count&&Number(t.amount)>0).sort((a,b)=>Number(b.min)-Number(a.min))[0];
      return {discount:tier?Number(tier.amount)*(tier.each?count:1):0,code:tier?.code||''};
    }
    setBundleCount(count) {
      count=Math.min(20,Math.max(1,count));
      const radio=this.offers.querySelector('[data-qty="'+Math.min(3,count)+'"]');
      if(!radio)return;radio.checked=true;
      $$('.offer',this.offers).forEach(l=>l.classList.toggle('is-active',l.contains(radio)));
      this.offer={qty:count,pct:Number(radio.dataset.pct)||0,discount:Number(radio.dataset.discount)||0,code:radio.dataset.code||''};
      const tier=this.bundleTier(count);this.offer.discount=tier.discount;this.offer.code=tier.code;
      this.setQty(count);this.renderBundleChoices();this.updateOfferPrices();
    }
    renderBundleChoices() {
      if (!this.offers) return;
      let box = this.querySelector('[data-bundle-choices]');
      if (!box) {box=d.createElement('div');box.dataset.bundleChoices='';box.className='bundle-choices';}
      const quantity=this.querySelector('.pdp__qty');
      this.offers.hidden=true;
      if(quantity){quantity.hidden=false;quantity.after(box);}else{this.offers.after(box);}
      let deals=this.querySelector('[data-pair-deals]');
      if(!deals){deals=d.createElement('div');deals.dataset.pairDeals='';deals.className='pair-deals';box.before(deals);}
      box.before(deals);
      deals.replaceChildren();
      [2,3,4].forEach(count=>{const saving=this.bundleTier(count).discount;if(!saving||saving>=this.variant.price*count)return;const button=d.createElement('button');button.type='button';button.className='pair-deal';button.setAttribute('aria-pressed',String(this.offer.qty===count));const title=d.createElement('strong'),amount=d.createElement('span');title.textContent=count+' '+(this.meta.unit||'item')+'s · '+fm(this.variant.price*count-saving);const original=Math.max(this.variant.compare||0,this.variant.price)*count,final=this.variant.price*count-saving;amount.textContent='Save '+fm(original-final)+' · '+Math.round((original-final)/original*100)+'% OFF';button.append(title,amount);button.onclick=()=>this.setBundleCount(count);deals.append(button);});
      deals.hidden=!deals.children.length;
      box.hidden=this.offer.qty<2||this.meta.single;if(box.hidden)return;
      const previous=[...box.querySelectorAll('fieldset')].map(g=>[...g.querySelectorAll('select')].map(s=>s.value));
      box.replaceChildren();
      for(let pair=0;pair<this.offer.qty;pair++) {
        const row=d.createElement('div');row.className='bundle-pair';
        const summary=d.createElement('div'),thumb=d.createElement('img'),title=d.createElement('span');summary.className='bundle-pair__heading';
        thumb.width=40;thumb.height=48;thumb.alt='';thumb.dataset.bundleThumb='';title.dataset.bundleSummary='';summary.append(thumb,title);row.append(summary);
        const group=d.createElement('fieldset');
        this.variant.options.forEach((value,index)=>{
          const label=d.createElement('label'),select=d.createElement('select');label.textContent=this.meta.optionNames?.[index]||'Option '+(index+1);select.dataset.bundleOption=String(index);select.setAttribute('aria-label',(this.meta.unit||'Item')+' '+(pair+1)+' '+label.textContent);
          [...new Set(this.variants.map(v=>v.options[index]))].forEach(name=>{const option=d.createElement('option');option.value=name;option.textContent=name;option.selected=name===(previous[pair]?.[index]||value);select.append(option);});label.append(select);group.append(label);
        });
        const status=d.createElement('p');status.dataset.bundleStatus='';status.setAttribute('role','status');group.append(status);
        const remove=d.createElement('button');remove.type='button';remove.className='bundle-pair__remove';remove.textContent='− Remove '+(this.meta.unit||'item');remove.onclick=()=>{group.remove();this.setBundleCount(this.offer.qty-1);};group.append(remove);row.append(group);box.append(row);
      }
      const footer=d.createElement('div');footer.className='bundle-choices__footer';const saving=d.createElement('span');saving.textContent=this.offer.discount?'You save '+fm(this.offer.discount):'';
      const total=d.createElement('strong');total.dataset.bundleTotal='';footer.append(saving,total);box.append(footer);
      box.onchange=()=>{this.updateBundleStatus();};this.updateBundleStatus();
    }
    bundleVariants() {
      const box=this.querySelector('[data-bundle-choices]');
      if (!box || box.hidden) return null;
      return [...box.querySelectorAll('fieldset')].map(group=>{const options=[...group.querySelectorAll('select')].map(s=>s.value);return this.variants.find(v=>v.options.every((o,i)=>o===options[i]));});
    }
    updateBundleStatus() {
      const variants=this.bundleVariants();if(!variants)return;
      this.querySelectorAll('[data-bundle-status]').forEach((el,i)=>{el.textContent=variants[i]?.available?'':'This combination is unavailable. Choose another size or colour.';
        const row=el.closest('.bundle-pair'),v=variants[i];row.querySelector('[data-bundle-summary]').textContent=(this.meta.unit||'Item')+' '+(i+1)+' · '+(v?v.options.join(' / '):'Choose options');const img=row.querySelector('img');img.src=v?.img||this.variant.img||'';
      });
      const total=this.querySelector('[data-bundle-total]');const saleTotal=variants.reduce((sum,v)=>sum+(v?.price||0),0),original=variants.reduce((sum,v)=>sum+Math.max(v?.compare||0,v?.price||0),0),final=saleTotal-(this.offer.discount||0);if(total)total.textContent='Total '+fm(final);const saving=this.querySelector('.bundle-choices__footer>span');if(saving)saving.textContent='Total savings '+fm(original-final)+' ('+Math.round((original-final)/original*100)+'% OFF)';
    }
    cartItems() {
      const variants=this.bundleVariants();
      if(!variants)return [{id:this.variant.id,quantity:this.getQty()}];
      if(variants.some(v=>!v?.available))throw new Error('Please choose available options for every item.');
      const items=[];variants.forEach(v=>{const item=items.find(x=>x.id===v.id);if(item)item.quantity++;else items.push({id:v.id,quantity:1});});return items;
    }
    updateOfferPrices() {
      if (!this.offers || !this.variant) return;
      $$('.offer', this.offers).forEach((l) => {
        const inp = $('input', l);
        const q = inp.checked && this.offer.qty>3 ? this.offer.qty : Number(inp.dataset.qty) || 1;
        const title=l.querySelector('.offer__title');if(title)title.textContent=q+'-'+(q===1?'Pair':'Pairs');
        const pct = Number(inp.dataset.pct) || 0;
        const tot = this.variant.price * q;
        const fin = tot - (Number(inp.dataset.discount) || Math.round((tot * pct) / 100));
        const f = $('[data-offer-final]', l);
        const t = $('[data-offer-total]', l);
        if (f) f.textContent = fm(fin);
        if (t) t.textContent = fm(tot);
      });
    }
    item() {
      const v = this.variant;
      return {
        variantId: v.id, quantity: this.getQty(), title: this.meta.title, variantTitle: this.meta.single ? '' : v.title,
        price: v.price, compare: v.compare, image: v.img, productId: this.meta.id, handle: this.meta.handle, url: this.meta.url, tags: this.meta.tags || []
      };
    }
    orderNow(btn) {
      const v = this.variant;
      if (!v || !v.available) return;
      const s = HA.settings;
      let cartItems;try{cartItems=this.cartItems();}catch(error){HA.toast(error.message);return;}
      const items=cartItems.map(entry=>{const variant=this.variants.find(v=>v.id===entry.id);return {...this.item(),variantId:variant.id,quantity:entry.quantity,variantTitle:variant.title,price:variant.price,image:variant.img};});
      const item = this.item();
      const code = this.offer && this.offer.code ? this.offer.code : '';
      HA.publish('order_now_click', { product_id: item.productId, variant_id: v.id, quantity: item.quantity, value: (v.price * item.quantity) / 100, currency: HA.currency, mode: s.orderMode });
      if (s.orderMode === 'instant' && s.engine && HA.cod && HA.cod.open) {
        HA.cod.open({ items, code, source: 'product' }, btn);
        return;
      }
      btn.classList.add('is-loading');
      setTimeout(() => btn.classList.remove('is-loading'), 6000);
      location.href = HA.checkoutUrl(cartItems, code);
    }
    async addToCart() {
      const v=this.variant;if(!v||!v.available||this._adding)return;
      this._adding=true;const btn=$('[data-add-to-cart]',this);
      if(btn){btn.disabled=true;btn.classList.add('is-loading');btn.setAttribute('aria-busy','true');}
      try{
        await HA.cart.add(this.cartItems());
        let offerError=null;
        if(this.offer&&this.offer.code){try{await HA.cart.applyDiscount(this.offer.code);}catch(error){offerError=error;}}
        const qv=this.closest('ha-drawer');if(qv&&qv.id==='QuickView')qv.close(true);
        HA.cart.afterAdd();
        if(offerError)HA.toast(HA.strings.addedOfferFailed||'Added to your bag. The offer could not be applied; check your bag before checkout.');
      }catch(error){HA.toast(error.message||HA.strings.cartError);}
      finally{this._adding=false;if(btn){btn.disabled=!this.variant?.available;btn.classList.remove('is-loading');btn.removeAttribute('aria-busy');}}
    }
    initGallery() {
      this.track = $('[data-gallery-track]', this);
      if (!this.track) return;
      const dots = $$('.gallery__dot', this);
      const cur = $('[data-gallery-current]', this);
      $$('[data-gallery-step]', this).forEach(button => on(button, 'click', () => {
        const items = $$('.gallery__item', this.track);
        let current = 0;
        items.forEach((item, index) => { if (Math.abs(item.offsetLeft - this.track.scrollLeft) < Math.abs(items[current].offsetLeft - this.track.scrollLeft)) current = index; });
        const next = (current + Number(button.dataset.galleryStep) + items.length) % items.length;
        this.track.scrollTo({left: items[next].offsetLeft, behavior: reduced ? 'auto' : 'smooth'});
      }));
      if (!dots.length && !cur) return;
      const upd = () => {
        const items = $$('.gallery__item', this.track);
        let idx = 0; let best = Infinity;
        items.forEach((it, k) => { const dist = Math.abs(it.offsetLeft - this.track.scrollLeft); if (dist < best) { best = dist; idx = k; } });
        dots.forEach((dt, k) => dt.classList.toggle('is-active', k === idx));
        if (cur) cur.textContent = idx + 1;
      };
      on(this.track, 'scroll', debounce(upd, 40), { passive: true });
    }
    openZoom(btn) {
      const btns = $$('[data-zoom]', this);
      let lb = $('.lightbox');
      if (!lb) {
        lb = d.createElement('div');
        lb.className = 'lightbox';
        lb.setAttribute('role', 'dialog');
        lb.setAttribute('aria-modal', 'true');
        lb.innerHTML = `<button type="button" class="icon-btn lightbox__x" aria-label="${esc(HA.strings.close || 'Close')}">${HA.icons.close}</button><div class="lightbox__list"></div>`;
        d.body.appendChild(lb);
        const close = () => {
          lb.classList.remove('is-open');
          if (!openDrawers.length) html.classList.remove('is-locked');
          if (lb._opener) lb._opener.focus({ preventScroll: true });
        };
        on(lb, 'click', (e) => { if (e.target.closest('.lightbox__x') || e.target.tagName === 'IMG') close(); });
        on(d, 'keydown', (e) => { if (e.key === 'Escape' && lb.classList.contains('is-open')) close(); });
      }
      const list = $('.lightbox__list', lb);
      list.innerHTML = '';
      let target = null;
      btns.forEach((b) => {
        const im = new Image();
        const gi = $('img', b);
        if (gi) { im.width = gi.getAttribute('width') || 1200; im.height = gi.getAttribute('height') || 1600; im.alt = gi.alt || ''; }
        im.decoding = 'async';
        im.loading = b === btn ? 'eager' : 'lazy';
        im.src = b.dataset.zoomSrc;
        list.appendChild(im);
        if (b === btn) target = im;
      });
      lb._opener = btn;
      lb.classList.add('is-open');
      html.classList.add('is-locked');
      requestAnimationFrame(() => { if (target) lb.scrollTop = target.offsetTop; $('.lightbox__x', lb).focus({ preventScroll: true }); });
    }
    initStickyBar() {
      const bar = $('[data-sticky-buy]', this);
      const buy = $('[data-buy]', this);
      if (!bar || !buy || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        d.body.classList.toggle('has-sticky-buy', show);
      }).observe(buy);
    }
    initStickable() {
      const el = $('.pdp__sticky', this);
      if (!el) return;
      const chk = () => el.classList.toggle('is-stickable', el.offsetHeight + 140 < window.innerHeight);
      chk();
      on(window, 'resize', debounce(chk, 200));
      if ('ResizeObserver' in window) new ResizeObserver(debounce(chk, 120)).observe(el);
    }
  }
  if (!customElements.get('ha-product')) customElements.define('ha-product', HaProduct);

  /* ---------- Recommendations ---------- */
  const lazyRun = (el, fn, margin = '300px') => {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    const io = new IntersectionObserver(([en]) => { if (en.isIntersecting) { io.disconnect(); fn(); } }, { rootMargin: margin });
    io.observe(el);
  };
  class HaRecs extends HTMLElement {
    connectedCallback() {
      if (this._init || !this.dataset.url) return;
      this._init = true;
      if (this.querySelector('.rail')) return;
      lazyRun(this, async () => {
        try {
          const doc = await HA.fetchHTML(this.dataset.url);
          const fresh = doc.querySelector('ha-recs');
          if (fresh && fresh.querySelector('.rail')) { this.innerHTML = fresh.innerHTML; revealIn(this); }
          else { const s = this.closest('section'); if (s) s.hidden = true; }
        } catch (e) { const s = this.closest('section'); if (s) s.hidden = true; }
      });
    }
  }
  if (!customElements.get('ha-recs')) customElements.define('ha-recs', HaRecs);

  /* ---------- Recently viewed ---------- */
  class HaRecent extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      const cur = this.dataset.current;
      const list = store.get(RV_KEY, []).filter((h) => h && h !== cur).slice(0, Number(this.dataset.limit) || 8);
      if (!list.length) return;
      const sec = this.closest('[data-recent-section]');
      lazyRun(sec || this, async () => {
        const track = $('[data-recent-track]', this);
        if (!track) return;
        const cards = await Promise.all(list.map((h) => HA.fetchHTML(HA.path(`/products/${encodeURIComponent(h)}?section_id=ha-card`)).then((doc) => doc.querySelector('.card')).catch(() => null)));
        const ok = cards.filter(Boolean);
        if (!ok.length) return;
        ok.forEach((c) => { const w = d.createElement('div'); w.className = 'rail__item'; w.appendChild(d.importNode(c, true)); track.appendChild(w); });
        if (sec) sec.hidden = false;
        $$('ha-slider', this).forEach((s) => s.update && s.update());
        revealIn(this);
      }, '600px');
    }
  }
  if (!customElements.get('ha-recent')) customElements.define('ha-recent', HaRecent);

  /* ---------- Reels ---------- */
  class HaReel extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.video = $('video', this);
      if (!this.video) return;
      const v = this.video;
      v.muted = true; v.playsInline = true; v.loop = true;
      const btn = $('[data-reel-sound]', this);
      on(btn, 'click', (e) => {
        e.preventDefault();
        const unmute = v.muted;
        $$('ha-reel').forEach((r) => {
          if (r !== this && r.video) { r.video.muted = true; const b = $('[data-reel-sound]', r); if (b) { b.innerHTML = HA.icons.mute; b.setAttribute('aria-pressed', 'false'); } }
        });
        v.muted = !unmute;
        btn.innerHTML = unmute ? HA.icons.sound : HA.icons.mute;
        btn.setAttribute('aria-pressed', unmute ? 'true' : 'false');
        if (unmute) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => {
          if (en.isIntersecting && en.intersectionRatio >= 0.5 && !reduced) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
          else v.pause();
        }, { threshold: [0, 0.5, 1] }).observe(this);
      }
    }
  }
  if (!customElements.get('ha-reel')) customElements.define('ha-reel', HaReel);

  /* ---------- Shop the look ---------- */
  class HaLook extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      const dots = $$('[data-look-dot]', this);
      const items = $$('[data-look-item]', this);
      const act = (i) => {
        dots.forEach((x) => x.classList.toggle('is-active', x.dataset.lookDot === i));
        items.forEach((x) => x.classList.toggle('is-active', x.dataset.lookItem === i));
      };
      dots.forEach((dt) => {
        on(dt, 'click', () => {
          act(dt.dataset.lookDot);
          const it = items.find((x) => x.dataset.lookItem === dt.dataset.lookDot);
          if (it && !mqDesk.matches) it.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest' });
        });
        on(dt, 'mouseenter', () => act(dt.dataset.lookDot));
      });
      items.forEach((it) => on(it, 'mouseenter', () => act(it.dataset.lookItem)));
      if (dots[0]) act(dots[0].dataset.lookDot);
    }
  }
  if (!customElements.get('ha-look')) customElements.define('ha-look', HaLook);

  /* ---------- Countdown ---------- */
  class HaCountdown extends HTMLElement {
    connectedCallback() {
      const raw = (this.dataset.end || '').trim();
      const tz = this.dataset.tz || '+05:00';
      const m = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
      if (!m) return;
      const pad = (n) => String(n).padStart(2, '0');
      const end = new Date(`${m[1]}-${pad(m[2])}-${pad(m[3])}T${pad(m[4] == null ? 23 : m[4])}:${m[5] == null ? '59' : m[5]}:00${tz}`).getTime();
      if (isNaN(end)) return;
      const els = {};
      $$('[data-cd]', this).forEach((e) => { els[e.dataset.cd] = e; });
      const tick = () => {
        let s = Math.floor((end - Date.now()) / 1000);
        if (s <= 0) {
          s = 0;
          clearInterval(this.t);
          const sec = this.closest('[data-countdown-section]');
          if (sec && !HA.designMode) sec.hidden = true;
        }
        const vals = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
        Object.keys(vals).forEach((k) => { if (els[k]) els[k].textContent = pad(vals[k]); });
      };
      tick();
      clearInterval(this.t);
      this.t = setInterval(tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.t); }
  }
  if (!customElements.get('ha-countdown')) customElements.define('ha-countdown', HaCountdown);

  /* ---------- Delivery estimate ---------- */
  const initDelivery = (root = d) => {
    const tpl = HA.strings.deliveryDates;
    if (!tpl) return;
    $$('[data-delivery]', root).forEach((el) => {
      const min = Number(el.dataset.min) || 2;
      const max = Math.max(min, Number(el.dataset.max) || 5);
      const t = $('[data-delivery-text]', el);
      if (!t) return;
      const add = (n) => { const dt = new Date(); let k = 0; while (k < n) { dt.setDate(dt.getDate() + 1); if (dt.getDay() !== 0) k++; } return dt; };
      const f = (dt) => dt.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
      t.innerHTML = tpl.replace(/%from|\{\{\s*from\s*\}\}/, esc(f(add(min)))).replace(/%to|\{\{\s*to\s*\}\}/, esc(f(add(max))));
    });
  };

  /* ---------- Predictive search ---------- */
  const initPredictive = () => {
    const form = $('[data-predictive-form]');
    if (!form || form._init) return;
    form._init = true;
    const input = $('[data-predictive-input]', form);
    const results = $('[data-predictive-results]');
    const popular = $('[data-predictive-popular]');
    const dr = form.closest('ha-drawer');
    if (dr) on(dr, 'drawer:open', () => { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } });
    if (!input || !results || HA.settings.predictive === false) return;
    let ctrl = null;
    const run = debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; if (popular) popular.hidden = false; return; }
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      results.classList.add('is-loading');
      try {
        const url = `${HA.routes.predictive}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,query&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=ha-predictive-search`;
        const doc = await HA.fetchHTML(url, ctrl ? { signal: ctrl.signal } : {});
        const pred = doc.querySelector('.pred');
        results.innerHTML = pred ? pred.outerHTML : '';
        if (popular) popular.hidden = !!pred;
        HA.publish('search', { query: q });
      } catch (e) {
        if (e.name !== 'AbortError') results.innerHTML = '';
      } finally {
        results.classList.remove('is-loading');
      }
    }, 260);
    on(input, 'input', run);
  };

  /* ---------- Facets / collection ---------- */
  const facetUrl = (form) => {
    const params = new URLSearchParams();
    new FormData(form).forEach((v, k) => { if (String(v).trim() !== '') params.append(k, v); });
    const qs = params.toString();
    return form.action.split('?')[0] + (qs ? '?' + qs : '');
  };
  const renderFacets = async (sid, url, push = true) => {
    const sec = $(`[data-section="${sid}"]`);
    const results = sec && $('[data-results]', sec);
    if (!results) { location.href = url; return; }
    results.classList.add('is-loading');
    try {
      const u = new URL(url, location.origin);
      u.searchParams.set('section_id', sid);
      const doc = await HA.fetchHTML(u.toString());
      const fresh = doc.querySelector('[data-results]');
      if (fresh) results.innerHTML = fresh.innerHTML;
      const fb = doc.querySelector('[data-facets-body]');
      const cur = $(`#FacetForm-${sid} [data-facets-body]`);
      if (fb && cur) {
        const opened = $$('details', cur).map((x) => x.open);
        cur.innerHTML = fb.innerHTML;
        $$('details', cur).forEach((x, i) => { if (opened[i] !== undefined) x.open = opened[i]; });
      }
      if (push) {
        const clean = new URL(url, location.origin);
        clean.searchParams.delete('section_id');
        history.pushState({ facets: sid }, '', clean.pathname + clean.search);
      }
      applyDensity();
      revealIn(results);
      const cnt = $('[data-results-count]', results);
      HA.publish('filter', { url: u.pathname + u.search, count: cnt ? cnt.textContent.trim() : '' });
    } catch (e) {
      location.href = url;
    } finally {
      results.classList.remove('is-loading');
    }
  };
  const initFacets = (root = d) => {
    $$('[data-facets]', root).forEach((form) => {
      if (form._init) return;
      form._init = true;
      const sid = form.id.replace('FacetForm-', '');
      try { history.replaceState(Object.assign({}, history.state, { facets: sid }), ''); } catch (e) { /* noop */ }
      const live = debounce(() => renderFacets(sid, facetUrl(form)), 450);
      on(form, 'change', (e) => { if (e.target.type !== 'number') live(); });
      on(form, 'input', (e) => { if (e.target.type === 'number') live(); });
      on(form, 'submit', (e) => {
        e.preventDefault();
        renderFacets(sid, facetUrl(form));
        const dr = form.closest('ha-drawer');
        if (dr) dr.close();
      });
    });
  };
  on(d, 'click', (e) => {
    const a = e.target.closest('[data-facet-remove], [data-facets-clear]');
    if (!a) return;
    const form = a.closest('[data-facets]');
    const sec = a.closest('[data-section]');
    const sid = form ? form.id.replace('FacetForm-', '') : sec && sec.dataset.section;
    if (!sid) return;
    e.preventDefault();
    renderFacets(sid, a.href);
    if (form) { const dr = form.closest('ha-drawer'); if (dr) dr.close(); }
  });
  on(window, 'popstate', (e) => { if (e.state && e.state.facets) renderFacets(e.state.facets, location.href, false); });

  on(d, 'click', async (e) => {
    const a = e.target.closest('[data-load-more]');
    if (!a) return;
    const sec = a.closest('[data-section]');
    if (!sec) return;
    e.preventDefault();
    a.classList.add('is-loading');
    a.setAttribute('aria-busy', 'true');
    try {
      const u = new URL(a.href, location.origin);
      u.searchParams.set('section_id', sec.dataset.section);
      const doc = await HA.fetchHTML(u.toString());
      const grid = $('[data-grid]', sec);
      doc.querySelectorAll('[data-grid] > .grid__item').forEach((it) => { it.classList.add('is-new'); grid.appendChild(d.importNode(it, true)); });
      const more = $('[data-more]', sec);
      const fresh = doc.querySelector('[data-more]');
      if (more) { if (fresh && fresh.querySelector('[data-load-more]')) more.innerHTML = fresh.innerHTML; else if (fresh) more.innerHTML = fresh.innerHTML; else more.remove(); }
    } catch (err) {
      location.href = a.href;
    }
  });

  const applyDensity = () => {
    const val = store.get('ha_dens', 'b');
    $$('[data-grid]').forEach((g) => { g.dataset.dens = val; });
    $$('[data-density]').forEach((b) => { b.classList.toggle('is-active', b.dataset.density === val); b.setAttribute('aria-pressed', b.dataset.density === val ? 'true' : 'false'); });
  };
  on(d, 'click', (e) => {
    const b = e.target.closest('[data-density]');
    if (!b) return;
    store.set('ha_dens', b.dataset.density);
    applyDensity();
  });

  /* ---------- Share ---------- */
  on(d, 'click', async (e) => {
    const b = e.target.closest('[data-share]');
    if (!b) return;
    e.preventDefault();
    const data = { title: b.dataset.title || d.title, url: b.dataset.url || location.href };
    if (navigator.share) { try { await navigator.share(data); } catch (err) { /* cancelled */ } return; }
    try { await navigator.clipboard.writeText(data.url); HA.toast(HA.strings.copied); }
    catch (err) { window.prompt('', data.url); }
  });

  /* ---------- Footer accordions ---------- */
  const initFooter = () => {
    const set = () => { if (mqTab.matches) $$('[data-ftr-acc]').forEach((dt) => { dt.open = true; }); };
    set();
    if (mqTab.addEventListener) mqTab.addEventListener('change', set);
    $$('[data-ftr-acc] > summary').forEach((s) => on(s, 'click', (e) => { if (mqTab.matches) e.preventDefault(); }));
  };

  /* ---------- Theme editor ---------- */
  const bindEditor = () => {
    if (!HA.designMode) return;
    html.classList.add('rv-off');
    on(d, 'shopify:section:load', (e) => {
      const t = e.target;
      initAnn(t); initDelivery(t); initFacets(t); applyDensity(); revealIn(t);
      if (t.querySelector('[data-header]') || t.querySelector('.ann')) Header.bind();
      if (t.querySelector('[data-ftr-acc]')) initFooter();
      if (t.querySelector('[data-predictive-form]')) initPredictive();
    });
    on(d, 'shopify:block:select', (e) => {
      const t = e.target;
      const hero = t.closest('ha-hero');
      if (hero && hero.go) { hero.pause(); hero.go($$('[data-slide]', hero).indexOf(t)); }
      const ann = t.closest('[data-ann]');
      if (ann && ann._go) ann._go($$('.ann__msg', ann).indexOf(t));
      const tabBtn = t.closest('[data-tab]');
      if (tabBtn) tabBtn.click();
    });
    on(d, 'shopify:block:deselect', (e) => { const hero = e.target.closest('ha-hero'); if (hero && hero.play) hero.play(); });
  };

  /* ---------- Boot ---------- */
  const boot = () => {
    captureSource();
    Header.bind();
    initAnn();
    initDelivery();
    initPredictive();
    initFacets();
    applyDensity();
    initFooter();
    bindEditor();
    revealIn();
    on(window, 'pageshow', (e) => { if (e.persisted) { $$('.btn.is-loading').forEach((b) => b.classList.remove('is-loading')); HA.cart.refresh(); } });
    HA.publish('page_ready', { template: HA.template });
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
